export default "__VITE_ASSET__CK$2alah__"